import { STATE_CODE_BY_NAME } from '@shared-components/constants';
import { TCity } from '@shared-components/types';
import { strToSlug } from '@utils';

const addressZip = (address: string, zip?: string): string => {
	if (!zip) {
		return address;
	}

	return `${address}-${zip}`;
};

const cityAddressZip = (city: string, address?: string, zip?: string): string => {
	if (!address) {
		return city;
	}

	return `${city}/${addressZip(address, zip)}`;
};

export interface CityAddressParams {
	address?: string;
	city?: string;
	zip?: string;
}

export interface UrlTemplateParams extends CityAddressParams {
	stateStr: string;
}

export interface OfficePathParams {
	stateStrOptions: TCity;
	cityAddressOptions?: CityAddressParams;
}

// determine the state string by brand
const getStateCode = (city: TCity): string =>
	city?.stateAbbreviation || STATE_CODE_BY_NAME[city?.location?.state || 'default'] || STATE_CODE_BY_NAME.default;

const stateStrLookups: Record<string, (city: TCity) => string> = {
	fallback: getStateCode,
	lovet: getStateCode,
};

export const stateStrByBrand = (brand: string, params: TCity): string =>
	(stateStrLookups?.[brand] || stateStrLookups.fallback)(params);

// determine the office URL template by brand
const defaultOfficeUrlTemplate = ({ stateStr, city, address }: UrlTemplateParams): string => {
	if (!city) {
		return stateStr;
	}

	return `${stateStr}/${cityAddressZip(city, address)}`;
};

const officeUrlTemplates: Record<string, (params: UrlTemplateParams) => string> = {
	fallback: defaultOfficeUrlTemplate,
	lovet: defaultOfficeUrlTemplate,
};

export const officeURLByBrand = (brand: string, params: UrlTemplateParams) =>
	strToSlug((officeUrlTemplates?.[brand] || officeUrlTemplates.fallback)(params));

export const officePathByBrand = (brand: string, params: OfficePathParams) =>
	strToSlug(
		(officeUrlTemplates?.[brand] || officeUrlTemplates.fallback)({
			stateStr: stateStrByBrand(brand, params.stateStrOptions),
			...params.cityAddressOptions,
		})
	);
